export default {
  sceneAttribute: '场景属性',
  endingScene: '结束场景',
  sceneDesc: '请设置结束场景，方便后续计算试玩完成率',
  warnEnding: '至少保留一个结束场景',
  viewSetting: {
    single: '单场景视图',
    story: '故事版视图',
    global: '全局场景视图',
    play: '玩法场景视图',
  },
  playScene: {
    title: '玩法模板',
    back: '返回项目编辑',
    create: '创建玩法模板',
    none: '当前素材没有用到玩法模板',
    errorMsg: '粘贴操作包含当前场景不支持文件类型',
    action: {
      edit: '玩法编辑',
      bind: '绑定场景',
      unbind: '解绑场景',
      quick: '快捷排版',
      back: '返回作品编辑',
      delete: '删除',
      componentSetting: '点这里，可进入组件设置',
    },
    unbind: '未绑定',
    need: '未添加快捷布局',
    bindNote: '绑定成功',
    unbindNote: '解绑成功',
  },
  otherLayer: '其他',
  globalScene: {
    edit: '前往编辑',
    title: '全局场景',
    settingTips: {
      title:
        '全局设置可设置背景图、背景颜色、背景音乐、多语言，也可设计全局场景，以应用于所有场景。',
      name: '全局场景可添加各种图片、文本、音效、特效等，只需更改一项内容就可更改所有场景的设计。',
    },
    isGlobal: {
      checkboxLabel: '是否启用',
    },
    globalIndex: {
      top: '置于场景顶层',
      bottom: '置于场景底层',
    },
  },
}
